import {FC, PropsWithChildren} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

interface Props {
  title?: string
  hides?: Array<'footer' | 'header'>
  id: string
  buttonRef?: React.MutableRefObject<HTMLButtonElement | null>
  className?: string
  size?: 'sm' | 'lg' | 'xl'
}

const ModalDefault: FC<PropsWithChildren<Props>> = ({
  children,
  title,
  hides,
  id,
  buttonRef,
  className,
  size,
}) => {
  return (
    <div className={className || 'modal fade'} tabIndex={-1} id={id}>
      <div className={`modal-dialog ${size ? 'modal-' + size : ''}`}>
        <div className='modal-content'>
          {!hides?.includes('header') && (
            <div className='modal-header'>
              <h5 className='modal-title'>{title || 'Modal Title'}</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
          )}
          <div className='modal-body'>{children}</div>
          {!hides?.includes('footer') && (
            <div className='modal-footer'>
              <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                Close
              </button>
              {/* <button type='button' className='btn btn-primary'>
                Save
              </button> */}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ModalDefault
